module.exports = __webpack_public_path__ + "media/assets/images/front/img-front-3b-c73dbc5866065fd42cab6fda5514ca34.png";